var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "page-tabs" }, [
        _c(
          "a",
          {
            class: { active: _vm.currentTab === 0 },
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.currentTab = 0
              },
            },
          },
          [_vm._v(" 輪播設定 ")]
        ),
        _c(
          "a",
          {
            class: { active: _vm.currentTab === 1 },
            on: {
              click: function ($event) {
                $event.preventDefault()
                _vm.currentTab = 1
              },
            },
          },
          [_vm._v(" 區塊設定 ")]
        ),
      ]),
      _vm.currentTab === 0 ? _c("Carousel") : _c("Block"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }